import React from 'react'

const onlyEndSpaceAllowed = /^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*\s*$/;// to allow only chracters and disallow space at start
const startEndNotSpaceNotAllowed = /^[-a-zA-Z-()]+(\s+[-a-zA-Z-()]+)*$/; // to allow only chracters and disallow space at start and end
const numberAndTextAllowed = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/; // to allowe numbers and text only and disallow start and end
const allowAll = /(?!^ +$)^.+$/; //to allow all except all spaces and blancks
const allowAllWithLineBreak = /(?!^ +$)^.+$/s; // tp allow all including line breaks
const allowAlaphaNumericWithEndSpace = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*\s*$/; // to allowe numbers and text only and allow end space
const onlyNumber = /^[0-9]+$/;
const alphaNumSpecial = /[^a-zA-Z0-9\s\-._]/g;
// Flattening `([/\w.-]*)*` to `[/\w.-]*` killed the exponential blow-up, but the
// pattern stayed super-linear: `[\da-z.-]+`, `\.`, `[a-z.]{2,6}` and `[/\w.-]*` all
// accept `.`, so rejecting an input meant re-partitioning it across those four
// pieces. Cost grew quadratically -- 6ms at 1k characters, 700ms at 16k -- in a
// validator that runs on every keystroke of a URL field.
//
// The scan below accepts exactly the same strings (checked against the old
// pattern over 466,449 generated inputs) in one left-to-right pass. Each
// candidate dot is tried against a TLD run bounded at 6 characters, so the work
// per dot is constant and the whole check is linear in the input length.
const isLabelChar = (c) =>
  (c >= '0' && c <= '9') || (c >= 'a' && c <= 'z') || c === '.' || c === '-';
const isTldChar = (c) => (c >= 'a' && c <= 'z') || c === '.';
const isPathChar = (c) =>
  (c >= 'a' && c <= 'z') ||
  (c >= 'A' && c <= 'Z') ||
  (c >= '0' && c <= '9') ||
  c === '_' || c === '/' || c === '.' || c === '-';

const isHostWithTldAndPath = (value) => {
  const len = value.length;

  // Longest tail made only of path characters. The path has to start at or
  // before this index for the rest of the string to be consumable.
  let pathStart = len;
  while (pathStart > 0 && isPathChar(value[pathStart - 1])) pathStart -= 1;

  // Longest head made only of host-label characters. The separating dot has to
  // fall inside it.
  let labelRun = 0;
  while (labelRun < len && isLabelChar(value[labelRun])) labelRun += 1;

  for (let dot = 1; dot <= labelRun && dot < len; dot += 1) {
    if (value[dot] !== '.') continue;

    // A longer TLD can only help the path start earlier, so the longest run
    // that still fits in {2,6} is the only one worth testing.
    let tld = 0;
    while (tld < 6 && dot + 1 + tld < len && isTldChar(value[dot + 1 + tld])) tld += 1;
    if (tld >= 2 && dot + 1 + tld >= pathStart) return true;
  }

  return false;
};

// `(https?:\/\/)?` was optional, so a scheme-less host stays valid. String() keeps
// the coercion `RegExp.prototype.test` used to do for non-string input.
const isWebUrl = (value) => {
  const text = String(value);
  if (text.startsWith('http://') && isHostWithTldAndPath(text.slice(7))) return true;
  if (text.startsWith('https://') && isHostWithTldAndPath(text.slice(8))) return true;
  return isHostWithTldAndPath(text);
};

// end

export const regexValidator = (strInput, fieldType) => {
   
   switch(fieldType)
   {
        case 'text':{
          const regex = onlyEndSpaceAllowed;
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'textSpaceEndStart':{
          const regex = startEndNotSpaceNotAllowed;
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'number':{
          const regex = onlyNumber;
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'alphanumeric':{
          const regex =  numberAndTextAllowed
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'alphanumericEndSpace':{
          const regex =  allowAlaphaNumericWithEndSpace
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'alphanumspecial':{
          const regex =  alphaNumSpecial
          const isValid = !regex.test(strInput)
          return isValid;
        }
        case 'descriptionText':{
          const regex = allowAllWithLineBreak;
          const isValid = regex.test(strInput)
          return isValid;
        }
        case 'URL':{
          const isValid = isWebUrl(strInput)
          return isValid;
        }
        // end
        default:{
          return false;
        }
   }
}

